import { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { IDirectDealFilter } from '../../../../../constants/filter/directDealFilter.constant';
import { useGetOpenMarketProductsMetaQuery } from '../../../../../hooks/api/product/queries/useGetOpenMarketProductsMeta.query';
import { useAppSelector } from '../../../../../hooks/store/useStore';
import { createDirectDealFilterSearchParams } from '../../../../../utils/filter/createDirectDealFilterSearchParams.util';
import { DirectDealSortSlideModal } from './DirectDealSortSlideModal';

export const DirectDealListCountSortSection = () => {
  const [isSortModalOpen, setIsSortModalOpen] = useState(false);
  const directDealFilters = useAppSelector((state) => state.filter.directDealFilter.globalFilters);

  const { data: productsMeta } = useGetOpenMarketProductsMetaQuery({
    searchParam: createDirectDealFilterSearchParams({ filters: directDealFilters as IDirectDealFilter[] }),
  });

  const selectedSortOption = directDealFilters
    .find((filter) => filter.key === 'sorter')
    ?.options.find((option) => option.isSelected);

  return (
    <Container>
      <CountWrapper>
        <CountTitle>{'매물'}</CountTitle>
        {productsMeta && <Count>{`${productsMeta.totalCount.toLocaleString()}대`}</Count>}
      </CountWrapper>

      <SortButton onClick={() => setIsSortModalOpen(true)}>
        <SortButtonText>{selectedSortOption?.optionName}</SortButtonText>
        <Icon name={'AngleDown'} size={'Small'} fill={'#505363'} />
      </SortButton>

      <DirectDealSortSlideModal isShow={isSortModalOpen} closeModal={() => setIsSortModalOpen(false)} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0px 16px 16px 16px;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #ececf3);
`;

const CountWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CountTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const Count = styled(CountTitle)`
  color: var(--Light-Scheme-Color-primary-blue, #196eff);
`;

const SortButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  padding: 4px 10px;

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const SortButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */

  white-space: nowrap;
`;
